import { ReactNode } from "react";

import { cn } from "../utls/utils";
import Typography from "./typography";
import ThemedSpinner, { SpinnerSize } from "./spinner";

export interface HarperLoadingSpinnerProps {
  /**
   * Short status label rendered next to the spinner.
   */
  label?: string;
  /**
   * Optional longer helper text supporting the loading state.
   */
  description?: ReactNode;
  /**
   * Size for the embedded spinner.
   */
  size?: SpinnerSize;
  /**
   * Optional custom class name for the wrapper.
   */
  className?: string;
}

/**
 * Harper-branded loading indicator that pairs the core spinner with themed copy.
 */
export function HarperLoadingSpinner({
  label = "Loading", 
  description,
  size = "md",
  className,
}: HarperLoadingSpinnerProps) {
  return (
    <div
      data-testid="harper-loading-spinner"
      className={cn(
        "flex items-center gap-4 rounded-lg border border-beige-300 bg-cream-50 p-4 shadow-sm",
        className
      )}
      aria-live="polite"
    >
      <ThemedSpinner size={size} />
      <div className="space-y-1">
        <Typography variant="subtitle1" className="text-terracotta-700">
          {label}
        </Typography>
        {description ? (
          <Typography variant="body2" className="text-brown-600">
            {description}
          </Typography>
        ) : null}
      </div>
    </div>
  );
}

export default HarperLoadingSpinner;
